export default "role-customer = Заказчик\nrole-driver = Водитель\n\nyes = Да\nnot = Нет"